<template>
  <div
    data-pagination-mount
    class="
      layout/height:cap
      layout/width:100%
      "
    >
    <fade-transition>
      <paginated-list-controls
        v-if="showPaginationControls"
        :current-page="currentPage"
        :show-more-items-button-html="showMoreItemsButtonHTML"
        @fetch-paginated-items="handleShowMoreItemsClick"
      />
      <spinner v-if="showLoadingControls" />
    </fade-transition>
  </div>
</template>
<script>
import paginatedListControls from './paginated-list-controls.vue';
import spinner from 'Components/shared/spinner.vue';
import fadeTransition from 'Components/shared/fade-transition.vue';

export default {
  name: 'paginated-list-container',
  components: {
    'paginated-list-controls': paginatedListControls,
    'spinner': spinner,
    'fade-transition': fadeTransition,
  },
  props: {
    initialCurrentPage:  { type: Number, required: true },
    initialLastPage: { type: Number, required: true },
    showMoreItemsButtonHTML: { type: String, required: true },
    fetchPaginatedListFunc: { type: Function, required: true },
    fetchPaginatedListSetupFunc: { type: Function, required: false },
    fetchPaginatedListCompletedFunc: { type: Function, required: false },
    params: { type: URLSearchParams, required: false, default: null},
  },
  data() {
    return {
      currentPage: this.initialCurrentPage,
      lastPage: this.initialLastPage,
      handlingShowMoreItems: false,
    };
  },
  computed: {
    showPaginationControls: function() {
      return (this.currentPage < this.lastPage) && !this.handlingShowMoreItems;
    },
    showLoadingControls: function() {
      return this.handlingShowMoreItems;
    },
    searchParams: function() {
      if (this.params == null) {
        return new URLSearchParams({"page": this.currentPage});
      }
      this.params.append("page", this.currentPage);
      return this.params;
    },
  },
  methods: {
    lastItem: function() {
      return this.listInsertion().lastElementChild;
    },
    handleShowMoreItemsClick: async function() {
      this.currentPage++;
      this.handlingShowMoreItems = true;

      const lastItem = this.lastItem();

      if (this.fetchPaginatedListSetupFunc)
        this.fetchPaginatedListSetupFunc();

      await this.fetchPaginatedListFunc(this.searchParams)
        .then(res => this.appendPaginatedItems(res))
        .then(() => this.showPaginatedItems())
        .then(() => this.handlingShowMoreItems = false)
        .then(() => this.focusOnFirstPaginatedItem(lastItem))
        .then(() => this.fetchPaginatedListCompletedFunc ? this.fetchPaginatedListCompletedFunc() : null)
        .catch(error => {
          this.handlingShowMoreItems = false;
          console.error("handleShowMoreItemsClick failed with error: ", error);
        });
    },
    listContainer: function() {
      return document.querySelector('[data-pagination-container]');
    },
    listInsertion: function() {
      return document.querySelector('[data-pagination-insertion]');
    },
    appendPaginatedItems: function(paginatedItemsHTML) {
      this.listInsertion().insertAdjacentHTML('beforeend', paginatedItemsHTML);
    },
    focusOnFirstPaginatedItem: function(lastItem) {
      if (lastItem != null) {
        lastItem.nextElementSibling.querySelector("a").focus();
      }
    },
    showPaginatedItems: function() {
      this.listContainer().classList.remove("layout/none");
    },
  },
};
</script>
